import * as types from './mutations-types'
import memberApi from '../../../../api/wx-member/member/member'
import dictApi from '../../../../api/dict/dictionary-api'
import wx from 'weixin-js-sdk'
import FormatTableFieldUtils from '../../../../common/utils/format-table-field-util'
import * as DictionaryConstants from '../../../../constants/DictionaryConstants'
import * as DataTypeConstants from '../../../../constants/DataTypeConstants'
import { Loading } from 'element-ui'

export default {
  getMemberDetail: ({ commit }) => {
    return memberApi.getMemberDetail()
      .then(result => {
        let params = [
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'vehicleBrands',
            fieldPropName: 'vehicleBrandsName',
            fieldFormatParam: DictionaryConstants.MY_CAR_BRANDS
          },
          {
            fieldDataType: DataTypeConstants.FORMAT_TABLE_DICT,
            fieldPropCode: 'vehicleName',
            fieldPropName: 'vehicleNameName',
            fieldFormatParam: DictionaryConstants.MY_CAR_TYPE_NAME
          }
        ]
        return result && result.memberCarDTOList && FormatTableFieldUtils.formatTableFieldName(result.memberCarDTOList, params).then(res => {
          result.memberCarDTOList = res
          commit(types.MEMBER_DETAIL, result)
          return result
        })
      })
  },
  getWXSignature: ({ commit }, url) => {
    memberApi.getWXSignature({ url: url })
      .then(result => {
        console.log(result, 'dddd')
        wx.config({
          debug: false,
          appId: result.appId, // 必填,公众号的唯一标识
          timestamp: result.timestamp, // 必填,生成签名的时间戳
          nonceStr: result.nonceStr, // 必填,生成签名的随机串
          signature: result.signature, // 必填,签名
          jsApiList: ['scanQRCode'] // 必填,需要使用的JS接口列表
        })
        wx.ready(() => {
          wx.checkJsApi({
            jsApiList: ['scanQRCode'],
            success: function (res) {
              // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
              if (res.checkResult.scanQRCode === true) {
                wx.scanQRCode({ // 微信扫一扫接口
                  // desc: 'scanQRCode desc',
                  needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                  scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
                  success: function (res) {
                    const qrCode = res.resultStr // 当needResult 为 1 时，扫码返回的结果
                    console.log('qrCode', qrCode)
                    commit(types.SCAN_CODE, qrCode)
                  }
                })
              } else {
                alert('抱歉，当前客户端版本不支持扫一扫')
              }
            },
            fail: function (res) { // 检测getNetworkType该功能失败时处理
              alert('fail' + res)
            }
          })
        })
        /* 处理失败验证 */
        wx.error(function (res) {
          // config 信息验证失败会执行error函数,如签名过期导致验证失败,
          // 具体错误信息可以打开config的debug模式查看,也可以在返回的res参数中查看,对于SPA可以在这里更新签名
          alert('配置验证失败: ' + res.errMsg)
        })
      })
  },
  cancelCoupon: ({ commit }, data) => {
    return new Promise(resolve => {
      memberApi.cancelCoupon(data)
        .then(result => {
          resolve(result)
        })
    })
  },
  commitApplication: ({ commit }, data) => {
    return new Promise(resolve => {
      memberApi.commitApplication(data)
        .then(result => {
          resolve(result)
        })
    })
  },
  getUserInfo: ({ commit }, data) => {
    return new Promise(resolve => {
      memberApi.getUserInfo(data)
        .then(result => {
          resolve(result)
        })
    })
  },
  getCaptcha: ({ commit, state }, data) => {
    return new Promise(resolve => {
      memberApi.getCaptcha(data)
        .then(res => {
          resolve(res)
        })
    })
  },
  getCaptchaAuthNew: ({ commit, state }, data) => {
    return new Promise(resolve => {
      memberApi.getCaptchaAuthNew(data)
        .then(res => {
          resolve(res)
        })
    })
  },
  getCancelTypeOptions: ({ commit, state }, dictCode) => {
    dictApi.getSelectedDetails(dictCode)
      .then(res => {
        commit(types.CANCEL_TYPE_OPTIONS, res)
      })
  },
  getSelectProvinceInfo: ({ commit, state }, dictCode) => {
    dictApi.getSelectedDetails(dictCode)
      .then(res => {
        commit(types.MEMBER_CAR_ATTRIBUTION, res)
      })
  },
  uploadFileGetVinCode: ({ commit, state }, data) => {
    const loading = Loading.service({
      lock: true,
      text: '处理中，请稍后……',
      spinner: 'el-icon-loading',
      background: 'rgba(255,255,255,0.7)'
    })
    return new Promise(resolve => {
      memberApi.uploadFileGetVinCode(data)
        .then(res => {
          loading.close()
          resolve(res)
        })
    })
  },
  deleteCarInfoById: ({ commit, state }, data) => {
    return new Promise(resolve => {
      memberApi.deleteCarInfoById(data)
        .then(res => {
          resolve(res)
        })
    })
  },
  emptyQrCode: ({ commit, state }, data) => {
    commit(types.EMPTY_QR_CODE, data)
  },
  getFinancialProjectInstance: ({ commit, state }, data) => {
    memberApi.getFinancialProjectInstance(data)
      .then(res => {
        commit(types.FINANCIAL_PROJECT_INSTANCE, res)
      })
  },
  getStoredValueRecording: ({ commit, state }, data) => {
    memberApi.getStoredValueRecording(data)
      .then(res => {
        commit(types.STORED_VALUE_RECORD, res)
      })
  },
  getCarBrandOptions: ({ commit, state }, dictCode) => {
    dictApi.getSelectedDetails(DictionaryConstants.MY_CAR_BRANDS)
      .then(res => {
        commit(types.CAR_BRAND_OPTIONS, res)
      })
  },
  getCarTypeOptions: ({ commit, state }, dictCode) => {
    dictApi.getCarTypeByBrand(dictCode)
      .then(res => {
        commit(types.CAR_TYPE_NAME_OPTIONS, res)
      })
  },
  updateCarDetails: ({ commit, state }, dictCode) => {
    return new Promise(resolve => {
      dictApi.updateCarDetails(dictCode)
        .then(res => {
          resolve(res)
        })
    })
  },
  getDictInfosByTypeCode: ({ commit, state }, dictCode) => {
    dictApi.getDictInfosByTypeCode(DictionaryConstants.MARITAL_STATUS)
      .then(res => {
        commit(types.MARITAL_STATUS, res)
      })
    dictApi.getDictInfosByTypeCode(DictionaryConstants.TYPE_OCCUPATION)
      .then(res => {
        commit(types.TYPE_OCCUPATION, res)
      })
    dictApi.getDictInfosByTypeCode(DictionaryConstants.TYPE_HOBBY)
      .then(res => {
        commit(types.TYPE_HOBBY, res)
      })
    dictApi.getDictInfosByTypeCode(DictionaryConstants.TYPE_VEHICLE_USE)
      .then(res => {
        commit(types.TYPE_VEHICLE_USE, res)
      })
  },
  memberAuthentication: ({ commit, state }, dictCode) => {
    return new Promise(resolve => {
      dictApi.memberAuthentication(dictCode)
        .then(res => {
          resolve(res)
        })
    })
  },
  updateMemberDetailsById: ({ commit, state }, dictCode) => {
    return new Promise(resolve => {
      dictApi.updateMemberDetailsById(dictCode)
        .then(res => {
          resolve(res)
        })
    })
  },
  uploadFileGetMemberInfo: ({ commit, state }, data) => {
    const loading = Loading.service({
      lock: true,
      text: '处理中，请稍后……',
      spinner: 'el-icon-loading',
      background: 'rgba(255,255,255,0.7)'
    })
    return new Promise(resolve => {
      memberApi.uploadFileGetMemberInfo(data)
        .then(res => {
          loading.close()
          resolve(res)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/store/actions.js